module.exports = __webpack_public_path__ + "static/media/myFace.6f8d4918.png";